export default __webpack_public_path__ + "static/media/06_Have-a-picnic_Share.cd7010d8.jpg";